import { render, staticRenderFns } from "./automation-type-header.vue?vue&type=template&id=528df98f"
import script from "./automation-type-header.vue?vue&type=script&lang=js"
export * from "./automation-type-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports